import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { employmentStatusOptions } from "../../../../enums/profile/EmploymentStatus";
import { update_signup_form_values } from "../../../../store/actions/signupFlowData";
import { MultiStep } from "../../../molecules/MultiStep";
import ReactSelect from "../../../atoms/ReactSelect";
import {
  ModalPageBody,
  ModalPageFooter,
  ModalPageHeader,
  ModalPageHeading,
  ModalPageWrapper,
} from "../../../organisms/ModalPage";
import { questionStepperList } from "../helpers";
import { EmploymentStatusValidationSchema } from "../ProfileBuilderValidation";

const EmploymentStatus = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const employmentStatusPageData = useSelector(
    (state) => state.signupFlowData.signupPagesData?.["employment-status"]
  );
  const storeEmploymentStatusValue = useSelector(
    (state) => state.signupFlowData.signupFormValues?.employmentStatus
  );

  const [initialValues, setInitialValues] = useState({
    employmentStatus: storeEmploymentStatusValue || null,
  });

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_title: "Employment status | Profile builder | Sign up | Gloji",
    });
  }, []);

  const handleSubmit = (values) => {
    storeEmploymentStatusValue
      ? setInitialValues({ employmentStatus: storeEmploymentStatusValue })
      : setInitialValues(values);
    dispatch(update_signup_form_values(values));
    history.push("/sexual-orientation");
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={EmploymentStatusValidationSchema}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(props) => (
        <Form className="profile-builder-form">
          <Helmet>
            <title>Employment status | Profile builder | Sign up | Gloji</title>
          </Helmet>
          <ModalPageWrapper>
            <ModalPageBody className="with-sticky-footer">
              <ModalPageHeader
                className="modal-header_center"
                backButtonOnClick={() => {
                  history.goBack();
                }}
              >
                Profile
              </ModalPageHeader>

              <MultiStep step={3} list={questionStepperList} percent={30} />

              <ModalPageHeading>{employmentStatusPageData?.questions[0].question}</ModalPageHeading>
              <ReactSelect
                name="employmentStatus"
                options={employmentStatusOptions}
                label={employmentStatusPageData?.questions[0].label}
                labelCssClass="profile-builder__input-label"
              />
              <Accordion square={true} elevation={0} className="profile-builder__accrodion">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon fontSize="large" />}
                  aria-controls={`employmentStatus-question-explanation`}
                >
                  <span>{employmentStatusPageData?.questions[0].whyQuestion}</span>
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <span>{employmentStatusPageData?.questions[0].whyQuestionDetails}</span>
                    <p>
                      Visit our&nbsp;
                      <a target="_blank" href="/privacy">
                        privacy policy
                      </a>
                      &nbsp;page
                    </p>
                  </div>
                </AccordionDetails>
              </Accordion>
            </ModalPageBody>
            <ModalPageFooter className="sticky-footer">
              <Button type="submit" variant="contained" color="primary">
                Continue
              </Button>
            </ModalPageFooter>
          </ModalPageWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default EmploymentStatus;
